// extracted by mini-css-extract-plugin
export default {"root":"Alert_root__-s5LD","small":"Alert_small__mY-A1","info":"Alert_info__NXF5R","error":"Alert_error__U73Cg"};